import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { FilterModel } from "src/app/views/pages/shared_components/filter-section/filter-section.component";
import { environment } from "src/environments/environment";

export interface MapBounds {
  ne_lat: number,
  ne_lng: number,
  sw_lat: number,
  sw_lng: number
}

export interface ApartmentMapFilter {
  bounds: MapBounds,
  filter: FilterModel
}

export interface ApartmentMapListItem {
  id: number,
  refNum: string,
  latitude: number,
  longitude: number
}

@Injectable({
  providedIn: 'root'
})
export class ApartmentService {
  constructor(
    private _http: HttpClient,
    private _authService: MadAuthService,
    private _subdomainService: SubdomainService
  ) { }

  fetchMap(payload: ApartmentMapFilter): Observable<{ data: ApartmentMapListItem[] }> {
    return this._http.post<{
      data: {
        id: number,
        ref_num: string,
        latitude: string,
        longitude: string
      }[]
    }>(
      environment.baseApiUrl + `api/v2/${this._subdomainService.subDomain}/comparables/apartments/map`,
      {
        payload
      },
      {
        headers: this._authService.getAuthHeaders()
      }
    ).pipe(
      map(response => {
        return {
          data: response.data.map(item => {
            return {
              id: item.id,
              refNum: item.ref_num,
              latitude: Number(item.latitude),
              longitude: Number(item.longitude)
            }
          })
        }
      })
    )
  }
}